import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface SiteThemeStore {
  themeMode: 'dark' | 'light';
  setThemeMode: (mode: 'dark' | 'light') => void;
  toggleTheme: () => void;
}

export const useSiteTheme = create<SiteThemeStore>()(
  persist(
    (set, get) => ({
      themeMode: 'light', // Default to light theme for the main site
      
      setThemeMode: (mode: 'dark' | 'light') => set({ themeMode: mode }),
      
      toggleTheme: () => {
        const currentMode = get().themeMode;
        set({ themeMode: currentMode === 'dark' ? 'light' : 'dark' });
      },
    }),
    {
      name: 'site-theme-storage', // Different storage key from microcircuits
      version: 1,
    }
  )
);